export default __webpack_public_path__ + "static/img-project-11-79168a6deb2e552d0c0bb8004c0c654e.png";